module.exports = __webpack_public_path__ + "img/good.cf7ea014.png";